<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter" id="ch00_fm05_dedic"><a id="page_v"></a>For Pat Kavanagh</p>
<p class="textcenter">My thanks are due to Don and Ruth Rendell whose hospitality gave me the space to work. To everyone at Bloomsbury, especially Liz Calder. To Philippa Brewster for her patience.<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_dedic.vue?88afecc2